import { useEffect } from 'react';
import type { GridFilterModel, GridPaginationModel, GridSortModel } from '@mui/x-data-grid';
import type { useSearchParams } from 'react-router-dom';

type UseGridUrlSyncParams = {
  syncStateToUrl: boolean;
  searchParams: URLSearchParams;
  setSearchParams: ReturnType<typeof useSearchParams>[1];
  paginationModel: GridPaginationModel;
  sortModel: GridSortModel;
  filterModel: GridFilterModel;
};

export const useGridUrlSync = ({
  syncStateToUrl,
  searchParams,
  setSearchParams,
  paginationModel,
  sortModel,
  filterModel,
}: UseGridUrlSyncParams): void => {
  useEffect(() => {
    if (!syncStateToUrl) return;
    const params = new URLSearchParams(searchParams);
    params.set('page', String(paginationModel.page));
    params.set('pageSize', String(paginationModel.pageSize));
    if (sortModel.length > 0) {
      params.set('sort', JSON.stringify(sortModel));
    } else {
      params.delete('sort');
    }
    if (filterModel.items.length > 0) {
      params.set('filters', JSON.stringify(filterModel));
    } else {
      params.delete('filters');
    }
    setSearchParams(params, { replace: true, preventScrollReset: true });
  }, [filterModel, paginationModel, searchParams, setSearchParams, sortModel, syncStateToUrl]);
};
